import * as yup from 'yup'
import {
    addressMax,
    addressMin,
    nameMin,
    poBoxRegex,
    shippingNameMax,
    shippingNameRegex,
    shippingNameStartingLetterRegex,
} from '@/src/modules/build-a-card/constants'

const isFullName = (value: string | undefined) => {
    if (!value) { return false}
    const nameArray = value.trim().split(' ')
    if (nameArray.length < 2) {
        return false;
    }
    if (nameArray[0].length < 1 || nameArray[nameArray.length - 1].length < 1) {
        return false;
    }
    return true
}

export const addressValidationSchema = yup.object({
    name: yup
        .string()
        .required('Name is required')
        .max(
            shippingNameMax,
            `Name cannot include more than ${shippingNameMax} characters`
        )
        .min(nameMin, `Name must include at least ${nameMin} characters`)
        .test(
            'test-if-full-name',
            'First and last name is required',
            (value) => {
                return isFullName(value)
            }
        )
        .test(
            'shippingName',
            'Shipping name must contain at least one alphanumeric character',
            (val: any) => !val || shippingNameRegex.test(val)
        )
        .test(
            'shippingNameFirstLetter',
            'Shipping name should be a non-numeric value',
            (val) => !val || shippingNameStartingLetterRegex.test(val)
        ),
    address1: yup
        .string()
        .required(
            'We were unable to find a valid address. Please confirm your entered information and try again.'
        )
        .max(
            addressMax,
            `Address cannot include more than ${addressMax} characters`
        )
        .min(
            addressMin,
            `Address must include at least ${addressMin} characters`
        )
        .test(
            'poBox',
            'For security purposes, we are unable to ship to P.O. Boxes. We apologize for the inconvenience.',
            (val: any) => !poBoxRegex.test(val)
        ),
    address2: yup
        .string()
        .optional()
        .max(
            addressMax,
            `Address 2 cannot include more than ${addressMax} characters`
        ),
    city: yup
        .string()
        .required('City is required')
        .max(
            addressMax,
            `City cannot include more than ${addressMax} characters`
        )
        .min(addressMin, `City must include at least ${addressMin} characters`),
    state: yup
        .string()
        .matches(/[a-z]{2}/i, 'Set a valid state')
        .required('State is required'),
    zip: yup
        .string()
        .matches(/\b\d{5}\b/g, 'Set a valid Zip code')
        .max(5)
        .required('Zip code is required'),
})

export const addressValidationSchemaWithDelivery =
    addressValidationSchema.shape({
        delivery: yup
            .string()
            .required('Select a delivery method')
            .matches(/^(?!empty\b)/i, 'Select a valid delivery method'),
    })
